/**
 * Display labels of the backend request types. The API sends enum names (ECG, HOLTER,
 * DERMATOLOGY_PHOTOS); anything unknown is shown as is.
 */
const REQUEST_TYPE_LABELS: Record<string, string> = {
    ECG: 'ECG',
    HOLTER: 'Holter',
    DERMATOLOGY_PHOTOS: 'Dermatologie',
};

/** Request types an expert can filter on, in display order. */
export const FILTERABLE_REQUEST_TYPES = ['ECG', 'HOLTER', 'DERMATOLOGY_PHOTOS'];

export function requestTypeLabel(requestType: string | null | undefined): string {
    if (!requestType) return '';
    return REQUEST_TYPE_LABELS[requestType] ?? requestType;
}
